export const MANUAL_REVIEW_CASE_RESOLVED_MESSAGE =
  "The case resolved successfully and the data has been sent.";

export const MANUAL_REVIEW_DOCUMENT_MARKED_BROKEN_MESSAGE =
  "Document marked as broken and email status set to FAILED.";

function normalizeMessage(message: string): string {
  return message.trim().replace(/\.+$/, "");
}

export function isManualReviewCaseResolvedMessage(
  message: string | null | undefined,
): boolean {
  if (message == null || typeof message !== "string") return false;
  const expected = normalizeMessage(MANUAL_REVIEW_CASE_RESOLVED_MESSAGE);
  return normalizeMessage(message) === expected;
}

export function isManualReviewDocumentMarkedBrokenMessage(
  message: string | null | undefined,
): boolean {
  if (message == null || typeof message !== "string") return false;
  const expected = normalizeMessage(MANUAL_REVIEW_DOCUMENT_MARKED_BROKEN_MESSAGE);
  return normalizeMessage(message) === expected;
}
